import React from "react";
import { BLOCK } from "../agent/agentContract";
import TextBlock from "./blocks/TextBlock";
import QuickReplyBlock from "./blocks/QuickReplyBlock";
import CtaChipsBlock from "./blocks/CtaChipsBlock";
import TableRefBlock from "./blocks/TableRefBlock";
import ContactTableBlock from "./blocks/ContactTableBlock";
import ProgressBlock from "./blocks/ProgressBlock";
import ConfirmationBlock from "./blocks/ConfirmationBlock";
import ConnectIntegrationBlock from "./blocks/ConnectIntegrationBlock";
import SummaryCardBlock from "./blocks/SummaryCardBlock";
import ErrorCtaBlock from "./blocks/ErrorCtaBlock";
import LivePreviewBlock from "./blocks/LivePreviewBlock";
import QuestionFormBlock from "./blocks/QuestionFormBlock";
import SequenceListBlock from "./blocks/SequenceListBlock";
import EntityCardsBlock from "./blocks/EntityCardsBlock";
import DraftReviewBlock from "./blocks/DraftReviewBlock";
import SellerProfilePreviewBlock from "./blocks/SellerProfilePreviewBlock";
import WebsiteInputBlock from "./blocks/WebsiteInputBlock";
import ChartBlock from "./blocks/ChartBlock";
import RecordDetailBlock from "./blocks/RecordDetailBlock";
import TimelineBlock from "./blocks/TimelineBlock";
import CitationsBlock from "./blocks/CitationsBlock";
import ThreadViewBlock from "./blocks/ThreadViewBlock";
import StatTileBlock from "./blocks/StatTileBlock";
import KpiRowBlock from "./blocks/KpiRowBlock";
import MeterBlock from "./blocks/MeterBlock";
import FunnelBlock from "./blocks/FunnelBlock";
import HeatmapBlock from "./blocks/HeatmapBlock";
import DumbbellBlock from "./blocks/DumbbellBlock";
import ComparisonGridBlock from "./blocks/ComparisonGridBlock";
import DivergingBarBlock from "./blocks/DivergingBarBlock";
import DataTableBlock from "./blocks/DataTableBlock";
import StepperBlock from "./blocks/StepperBlock";
import DiagramBlock from "./blocks/DiagramBlock";
import WidgetBlock from "./blocks/WidgetBlock";
import BarChartBlock from "./blocks/BarChartBlock";
import LineChartBlock from "./blocks/LineChartBlock";

const BLOCK_COMPONENTS = {
  [BLOCK.TEXT]: TextBlock,
  [BLOCK.QUICK_REPLIES]: QuickReplyBlock,
  [BLOCK.CTA_CHIPS]: CtaChipsBlock,
  [BLOCK.TABLE_REF]: TableRefBlock,
  [BLOCK.CONTACT_TABLE]: ContactTableBlock,
  [BLOCK.PROGRESS]: ProgressBlock,
  [BLOCK.CONFIRMATION]: ConfirmationBlock,
  [BLOCK.CONNECT_INTEGRATION]: ConnectIntegrationBlock,
  [BLOCK.SUMMARY_CARD]: SummaryCardBlock,
  [BLOCK.ERROR_CTA]: ErrorCtaBlock,
  [BLOCK.LIVE_PREVIEW]: LivePreviewBlock,
  [BLOCK.QUESTION_FORM]: QuestionFormBlock,
  [BLOCK.SEQUENCE_LIST]: SequenceListBlock,
  [BLOCK.ENTITY_CARDS]: EntityCardsBlock,
  [BLOCK.DRAFT_REVIEW]: DraftReviewBlock,
  [BLOCK.SELLER_PROFILE_PREVIEW]: SellerProfilePreviewBlock,
  [BLOCK.WEBSITE_INPUT]: WebsiteInputBlock,
  [BLOCK.CHART]: ChartBlock,
  [BLOCK.RECORD_DETAIL]: RecordDetailBlock,
  [BLOCK.TIMELINE]: TimelineBlock,
  [BLOCK.CITATIONS]: CitationsBlock,
  [BLOCK.THREAD_VIEW]: ThreadViewBlock,
  [BLOCK.STAT_TILE]: StatTileBlock,
  [BLOCK.KPI_ROW]: KpiRowBlock,
  [BLOCK.METER]: MeterBlock,
  [BLOCK.FUNNEL]: FunnelBlock,
  [BLOCK.HEATMAP]: HeatmapBlock,
  [BLOCK.DUMBBELL]: DumbbellBlock,
  [BLOCK.COMPARISON_GRID]: ComparisonGridBlock,
  [BLOCK.DIVERGING_BAR]: DivergingBarBlock,
  [BLOCK.DATA_TABLE]: DataTableBlock,
  [BLOCK.STEPPER]: StepperBlock,
  [BLOCK.DIAGRAM]: DiagramBlock,
  [BLOCK.WIDGET]: WidgetBlock,
  [BLOCK.BAR_CHART]: BarChartBlock,
  [BLOCK.LINE_CHART]: LineChartBlock
};

// Unknown block types from a newer agent render as nothing instead of
// crashing the thread — forward compatibility for the contract.
// `hidden` retracts an already-started block (e.g. a tool call that failed on
// a filter-vocabulary technicality and is being silently retried) — the user
// should never see internal retries surface as errors.
const BlockRenderer = ({ block, isStreaming }) => {
  const Component = BLOCK_COMPONENTS[block.type];
  if (!Component || block.hidden) return null;
  return <Component block={block} isStreaming={isStreaming} />;
};

export default BlockRenderer;
